/**
 * Zod schemas for set default address API endpoint
 * Shared between client and server code
 */

import { z } from 'zod';

// Response schema for setting default address
export const SetDefaultAddressResponseSchema = z.discriminatedUnion('success', [
  z.object({
    success: z.literal(true),
    address: z.object({
      id: z.number(),
      isDefault: z.number().nullable(),
    }),
  }),
  z.object({
    success: z.literal(false),
    error: z.string(),
  }),
]);

export type SetDefaultAddressResponse = z.infer<typeof SetDefaultAddressResponseSchema>;
